export default __webpack_public_path__ + "static/media/frg--walking-trails.56bb804e.png";